import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateEventTypeDocument } from './create.generated';

export const useCreateEventType = (options: ApiOptions<typeof CreateEventTypeDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(CreateEventTypeDocument, {
    ...useNotifications(CreateEventTypeDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.event_types.create_success'),
    }),
    ...options,
  });
};
